<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <app-admin-card-with-title
      [cardTitle]="t('app.register.to.race.basic.data')" [removeTopMargin]="true">
      <div class="row">
        <div class="col-12 col-xl-9">
          <div class="row">
            <div class="col-12 col-xl-7 mb-3">
              <!-- Race Name field-->
              <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage"
                                  [extraLanguages]="event?.extraLanguages" [hrKey]="'name'" [enKey]="'nameEng'"
                                  [itKey]="'nameIta'"
                                  [siKey]="'nameSlo'" [hrLabel]="'race.details.nameCro'"
                                  [enLabel]="'race.details.nameEn'"
                                  [itLabel]="'race.details.nameIt'" [siLabel]="'race.details.nameSlo'"/>
            </div>
            <div class="col-12 col-xl-5 mb-3">
              <!-- Organizer Name field-->
              <app-input type="text" formControlName="organizerName"
                         label="organizer.details.organizerName"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xl-7">
              <div class="row">
                <div class="col-12 col-xl-9 mb-3"><!-- League name field-->
                  <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage"
                                      [required]="false" [extraLanguages]="event?.extraLanguages"
                                      [hrKey]="'leagueName'"
                                      [enKey]="'leagueNameEn'" [itKey]="'leagueNameSl'" [siKey]="'leagueNameIt'"
                                      [hrLabel]="'event.item.leagueName'" [enLabel]="'event.item.leagueNameEn'"
                                      [itLabel]="'event.item.leagueNameIt'" [siLabel]="'event.item.leagueNameSl'"/>
                </div>
                <div class="col-12 col-xl-3 mb-3"><!-- Round Name field-->
                  <app-input type="number" formControlName="round" label="race.details.round" [min]="1"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-xl-6">
              <!-- Race Start - End-->
              <app-date-time-from-to-input
                formControlName="raceDates"
                [displayRangeErrorBeforeTouched]="true"
                [ranges]="{from: event?.start, to: event?.end}"
                [labelStart]="t('race.details.start.time')"
                [labelEnd]="t('race.details.end.time')"
                [invalidMessageKey]="'race.details.start.end.date.range.error'"
              />
            </div>
            <div class="col-12 col-xl-6">
              <!-- Application Start - End -->
              <app-date-time-from-to-input
                formControlName="registrationDates"
                [ranges]="{from: undefined, to: applicationMaxDate}"
                [calendarStart]="calendarStartDate"
                [displayRangeErrorBeforeTouched]="true"
                [labelStart]="t('race.details.registration.start')"
                [invalidMessageKey]="'race.details.start.end.application.range.error'"
                [labelEnd]="t('race.details.registration.end')"/>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <span class="fw-semibold text-uppercase">{{ t('race.details.logo.upload') }}</span>
          <app-drag-and-drop [isDisabled]="disableEditing" [selectedFile]="selectedImage"
                             (fileChange)="imageChange($event)"/>
        </div>
      </div>


    </app-admin-card-with-title>
    <div class="admin-card mt-3">
      <div class="row">
        <div class="col-xl-4 mb-3">
          <!-- Race status dropdown -->
          <app-select formControlName="status" [hasDefault]="true"
                      [items]="statuses" [valueKey]="'id'" [labelKey]="'id'" labelKeyPrefix="race.status."
                      label="race.details.status"/>
        </div>
        <div class="col-xl-4 mb-3">
          <!-- Sport dropdown -->
          <app-select formControlName="sport" [hasDefault]="true"
                      [items]="sports" [valueKey]="'id'" [labelKey]="'id'" labelKeyPrefix="app.common.sports."
                      label="race.details.sport"/>
        </div>
        <div class="col-xl-4 mb-3">
          <!-- Registration type dropdown -->
          <app-select formControlName="registrationType"
                      [hasDefault]="true" [items]="registrationTypes" [valueKey]="'id'" [labelKey]="'id'"
                      labelKeyPrefix="race.details.registration.type." label="race.details.registration.type"/>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 mb-3">
          <app-input type="number" formControlName="maxParticipants"
                     label="race.details.competitors.max" [min]="1"/>
        </div>

        <div class="col-xl-4 mb-3">
          <app-input type="number" formControlName="startEvery"
                     label="race.details.start.every"/>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 mb-3">
          <!-- Virtual Race dropdown -->
          <app-select formControlName="virtualRace"
                      [items]="[true, false]" [labels]="['app.common.yes', 'app.common.no']"
                      label="race.details.virutal.race"/>
        </div>
        <div class="col-xl-4 mb-3">
          <app-input type="number" formControlName="checkpointAmount"
                     label="race.details.checkpointAmount"/>
        </div>
        <div class="col-xl-4 mb-3">
          <app-input type="number" formControlName="refreshmentCheckpointAmount"
                     label="race.details.refreshmentCheckpointAmount"/>
        </div>
      </div>
      <div class="row">
        @if (inputForm.controls['length'].enabled) {
          <div class="col-12 col-xl mb-3">
            <app-input formControlName="length" label="race.details.length"/>
          </div>
        }
        @if (inputForm.controls['ascent'].enabled) {

          <div class="col-12 col-xl">
            <app-input ngDefaultControl type="number"
                       formControlName="ascent" label="race.details.ascent"/>
          </div>
        }
        @if (inputForm.controls['descent'].enabled) {
          <div class="col-12 col-xl">
            <app-input ngDefaultControl type="number"
                       formControlName="descent" label="race.details.descent"/>
          </div>
        }
        @if (inputForm.controls['maxAltitude'].enabled) {
          <div class="col-12 col-xl">
            <app-input ngDefaultControl type="number"
                       formControlName="maxAltitude" label="race.details.max.altitude"/>
          </div>
        }
        @if (inputForm.controls['minAltitude'].enabled) {
          <div class="col-12 col-xl">
            <app-input ngDefaultControl type="number"
                       formControlName="minAltitude" label="race.details.min.altitude"/>
          </div>
        }
      </div>
    </div>
    <app-action-buttons-row (onSave)="onSave()"/>
  </form>
</ng-container>
